import { createSlice } from '@reduxjs/toolkit';
const initial_device_map_state = {
    center: [55, 56.3],
    zoom: 17,
    size: [0, 0],
    highlight_rings: null,
};
export function getDeviceMapState(state, device_id) {
    const key = device_id ?? -1;
    if (state.items[key] == null) {
        state.items[key] = { ...initial_device_map_state };
    }
    return state.items[key];
}
const slice = createSlice({
    name: 'map',
    initialState: () => ({
        items: {},
        providers_config: window.PRELOAD.map_providers_config,
    }),
    reducers: {
        setMapCenterAndZoom: (state, { payload: { center, zoom, device_id }, }) => {
            getDeviceMapState(state, device_id).center = center;
            getDeviceMapState(state, device_id).zoom = zoom;
        },
        setMapCenter: (state, { payload: { center, device_id }, }) => {
            getDeviceMapState(state, device_id).center = center;
        },
        setMapZoom: (state, { payload: { zoom, device_id }, }) => {
            getDeviceMapState(state, device_id).zoom = zoom;
        },
        setMapSize: (state, { payload: { size, device_id }, }) => {
            getDeviceMapState(state, device_id).size = size;
        },
        showHighlightRings: (state, { payload: { loc, color, device_id }, }) => {
            getDeviceMapState(state, device_id).highlight_rings = { loc, color };
        },
        hideHighlightRings: (state, { payload: { device_id } }) => {
            getDeviceMapState(state, device_id).highlight_rings = null;
        },
    },
});
export const { setMapCenterAndZoom, setMapCenter, setMapZoom, setMapSize, showHighlightRings, hideHighlightRings, } = slice.actions;
export const mapReducer = slice.reducer;
